import './vendor/prompts';
import './core/helper';
import './core/heroic';
import './core/form';
import './debugger/alpine-debugger';
